module.exports = __webpack_public_path__ + "static/media/disney96.19f96539.png";